import { IRootState } from 'redux/reducers/rootReducer'
import { ISchedule } from 'redux/reducers/scheduleReducer'

export const getSchedule = (state: IRootState): ISchedule => {
  return state.schedule
}
